import type { FaireProductEntity } from "../../entity_types/product";

export const p_s9y25rn5j5: FaireProductEntity = {
  token: "p_s9y25rn5j5",
  type: "product",
  name: "4 X 6 Note Pad Holder (W/ Paper)",
  brandName: "Huang Acrylic",
  imageUrl:
    "https://cdn.faire.com/fastly/d7798741a82694ba596ded508c31966895bb5a92a346ae9b5dff66569502e390.jpeg",
  priceDollars: 7.47,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/022ee0ec782c41cf48697696a7b74c2517ee975677daaa38111eeb54e0c8d9a9.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
